import { popupsTasks } from '@gem/popups';

export * as audioSource from './audioSource/audioSource';
export * from './focusApp/focusApp';
export * as fullscreen from './fullscreen/fullscreen';
export * as onboarding from './onboarding/onboarding';
export * from './preloadImage/preloadImage';
export * from './searchLinks/searchLinks';
export * from './utils/asyncCopyToClipboard';
export * from './support/openSupport';
export * from './rightSidebar';
export * from './openAdminPanel/openAdminPanel';
export * from './changeAppLanguage/changeAppLanguage';

const {
  showConfirmWithCheckbox,
  showConfirmWithCloseBtn,
  showConfirm,
  showToast,
  showAlert,
  openPopup,
} = popupsTasks;

export {
  showConfirmWithCheckbox,
  showConfirmWithCloseBtn,
  showConfirm,
  showToast,
  showAlert,
  openPopup,
};
